// options
// var deploy_mode = 1; // 0-开发模式; 1-生产模式
// var deploy_mode_is_prod = false;

// var reg = /^(192.168.3.)/;
// if (window.location.hostname !== 'localhost' && !reg.test(window.location.hostname)) {
//   deploy_mode_is_prod = true;
// }

// var is_load_audio = false;
// sessionStorage.setItem("is_load_audio", is_load_audio);

// var audio_paths = ["assets/sounds/0.mp3", "assets/sounds/1.mp3", "assets/sounds/2.mp3",
//   "assets/sounds/young.mp3", "assets/sounds/Faded-Alan_Walker_Iselin_Solheim.mp3",
//   "assets/sounds/once_more.mp3", "sounds/Unstoppable-Sia.mp3",
//   "assets/sounds/Im_Alive-CÃ©line_Dion.mp3", "assets/sounds/Yesterday_Once_More_Carpenters.mp3"];
// var audio_path_index = Math.floor(Math.random() * (audio_paths.length - 1 - 0 + 1)) + 0;
// // var audio_path = "http://music.163.com/song/media/outer/url?id=1403685144.mp3";
// var audio_path = audio_paths[1];

// var frequencyData = [];
// sessionStorage.setItem("frequencyData", JSON.stringify(frequencyData));
// var fftSize = 64;
// var is_palying = false;
// sessionStorage.setItem("is_palying", is_palying);
// var is_ready = false;
// sessionStorage.setItem("is_ready", is_ready);
// var down_time_total = parseInt(5 * 1024 / 125);
// var down_time_current = down_time_total;
// sessionStorage.setItem("down_time_current", down_time_current);

(function ($) {
  $(function () {

    // function b_is_zh () {
    //   let is_zh = false;
    //   var jsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
    //   console.debug(jsSrc);
    //   if (jsSrc.indexOf('zh') >= 0) {
    //     // 假如浏览器语言是中文
    //     is_zh = true;
    //   }
    //   else if (jsSrc.indexOf('en') >= 0) {
    //     // 假如浏览器语言是英文
    //   }
    //   else {
    //     // 假如浏览器语言是其它语言
    //   }
    //   return is_zh;
    // }

    // 设置歌名
    // $("#audio-name-id").text("Faded - Alan Walker & Iselin Solheim");
    // $("#audio-name-id").css("font-size", "12px");
    // $("#audio-name-id").css("color", "#cccccc");
    // $("#audio-name-id").css("margin", "0 4px");

    // var xdiv0 = '<div class="small square el"></div>';
    // var xdiv1 = '<div class="small square"></div>';
    // var grid_w = 16;
    // var grid_h = 16;
    // for (var y = 0; y < grid_h; y++) {
    //   for (var x = 0; x < grid_w; x++) {
    //     $('#grid0-id').append(xdiv0);
    //     $('#grid1-id').append(xdiv1);
    //   }
    // }

    // let box_opacity = 0.25;

    // var is_auto_play = false;

    // function randomValues () {
    //   anime.timeline({
    //     endDelay: 5,
    //     easing: 'easeInOutQuad',
    //     direction: 'alternate',
    //     complete: randomValues
    //   })
    //     .add({ targets: '.staggering-grid-demo .el', background: 'rgb(' + anime.random(0, 255) + ',' + anime.random(0, 255) + ',' + anime.random(0, 255) + ')' }, 0)

    //   let heart = [
    //     [0, 0, 0, 0, 0, 0, 0, 0],
    //     [0, 1, 1, 0, 1, 1, 0, 0],
    //     [1, 0, 0, 1, 0, 0, 1, 0],
    //     [1, 0, 0, 0, 0, 0, 1, 0],
    //     [0, 1, 0, 0, 0, 1, 0, 0],
    //     [0, 0, 1, 0, 1, 0, 0, 0],
    //     [0, 0, 0, 1, 0, 0, 0, 0],
    //     [0, 0, 0, 0, 0, 0, 0, 0]
    //   ];

    //   for (let y = 0; y < 8; y++) {
    //     for (let x = 0; x < 16; x++) {
    //       if (x >= 8) {
    //         continue;
    //       }
    //       if (heart[y][x]) {
    //         $('#grid0-id > div:nth-child(' + (y * 16 + x + 1 + 4) + ')').css("background-color", "red");
    //         $('#grid0-id > div:nth-child(' + (y * 16 + x + 1 + 4) + ')').css("opacity", 1);
    //       }
    //     }
    //   }

    // }

    // // randomValues();

    // function clear_all () {
    //   for (let y = 0; y < grid_h; y++) {
    //     for (let x = 0; x < grid_w; x++) {
    //       $('#grid0-id > div:nth-child(' + (y * 16 + x + 1) + ')').css("background-color", "#FFFFFF");
    //       $('#grid0-id > div:nth-child(' + (y * 16 + x + 1) + ')').css("opacity", box_opacity);
    //     }
    //   }
    // }

    // function show_heart () {
    //   let heart = [
    //     [0, 0, 0, 0, 0, 0, 0, 0],
    //     [0, 1, 1, 0, 1, 1, 0, 0],
    //     [1, 0, 0, 1, 0, 0, 1, 0],
    //     [1, 0, 0, 0, 0, 0, 1, 0],
    //     [0, 1, 0, 0, 0, 1, 0, 0],
    //     [0, 0, 1, 0, 1, 0, 0, 0],
    //     [0, 0, 0, 1, 0, 0, 0, 0],
    //     [0, 0, 0, 0, 0, 0, 0, 0]
    //   ];

    //   for (let y = 0; y < 8; y++) {
    //     for (let x = 0; x < grid_w; x++) {
    //       if (x >= 8) {
    //         continue;
    //       }
    //       if (heart[y][x]) {
    //         let eid = ((y + 4) * 16 + x + 1 + 5);
    //         $('#grid0-id > div:nth-child(' + eid + ')').css("background-color", "red");
    //         $('#grid0-id > div:nth-child(' + eid + ')').css("opacity", 1);
    //         $('#grid0-id > div:nth-child(' + eid + ')').css("width", "16px");
    //         $('#grid0-id > div:nth-child(' + eid + ')').css("height", "16px");
    //       }
    //     }
    //   }
    // }

    // clear_all();
    // show_heart();

    // // animation0.play();
    // // animation1.play();

    // var Visualizer = function (config) {
    //   this.audioContext = null;
    //   this.analyser = null;
    //   this.source = null; //the audio source
    //   this.config = config;
    //   this.frequency = [];
    //   this.playing = false;
    //   this.ready = false;
    //   this.loadFailed = false;
    //   this.load_data_length = 0;
    // };
    // Visualizer.prototype = {
    //   init: function () {

    //     this._prepare();
    //     this.getData();
    //     this._analyser();
    //   },
    //   _prepare: function () {
    //     // 实例化一个音频上下文类型 window.AudioContext。目前 Chrome 和 Firefox 对其提供了支持，但需要相应前缀，
    //     // Chrome 中为 window.webkitAudioContext，Firefox 中为 mozAudioContext。
    //     // 所以为了让代码更通用，能够同时工作在两种浏览器中，只需要一句代码将前缀进行统一即可。
    //     window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext;
    //     try {
    //       this.audioContext = new AudioContext();
    //     } catch (e) {
    //       console.log(e);
    //     }
    //   },
    //   _analyser: function () {
    //     var that = this;
    //     that.analyser = that.audioContext.createAnalyser();
    //     that.analyser.smoothingTimeConstant = 0.85;
    //     that.analyser.fftSize = fftSize; // 傅里叶变换参数 简化成16个元素数组
    //     //将source与分析器连接
    //     that.source.connect(that.analyser);
    //     //将分析器与destination连接，这样才能形成到达扬声器的通路
    //     that.analyser.connect(that.audioContext.destination);
    //     that.frequency = new Uint8Array(that.analyser.frequencyBinCount);

    //   },
    //   getData: function () {
    //     var that = this;
    //     //建立缓存源
    //     that.source = that.audioContext.createBufferSource();
    //     var request = new XMLHttpRequest();
    //     //请求资源
    //     request.open('GET', that.config.url, true);
    //     // console.debug(request);
    //     request.responseType = 'arraybuffer';
    //     request.onreadystatechange = function () {

    //       if (request.readyState === 4) {
    //         if (request.status === 200) {
    //           that.ready = true;
    //         } else {
    //           that.loadFailed = true;
    //         }
    //       }
    //     };
    //     request.onload = function () {
    //       var audioData = request.response;
    //       //解码
    //       that.audioContext.decodeAudioData(audioData, function (buffer) {
    //         that.source.buffer = buffer;
    //         //  console.log(buffer.duration);//资源长度
    //         //                        that.source.connect(that.audioContext.destination);
    //         //将audioBufferSouceNode连接到audioContext.destination，
    //         // 这个AudioContext的destination也就相关于speaker（扬声器）。
    //         that.source.loop = that.config.loop || false;

    //       },
    //         function (e) { "Error with decoding audio data" + e.err });
    //     };
    //     request.send();
    //   },
    //   play: function () {
    //     var that = this;
    //     that.source.start(0);
    //     that.playing = true;
    //     var timer = setInterval(function () {
    //       that.analyser.getByteFrequencyData(that.frequency);
    //       if (that.source.buffer) {
    //         if (that.audioContext.currentTime > that.source.buffer.duration) {
    //           that.source.stop(0);
    //           that.playing = false;
    //           clearInterval(timer);

    //           is_auto_play = true;
    //           // clear_all();
    //           // show_heart();
    //           // animation0.play();
    //           // animation1.play();
    //           // removeBalloons();

    //           music();
    //         }
    //       }
    //     }, 10);
    //   },
    //   stop: function () {
    //     var that = this;
    //     that.source.stop(0);
    //     that.playing = false;
    //     that.ready = false;
    //   }

    // };

    // var v = new Visualizer({
    //   url: audio_path,//audio地址 没有写兼容跨域的方法，所以不能跨域
    //   loop: false//是否循环
    // });
    // is_load_audio = true;
    // sessionStorage.setItem("is_load_audio", is_load_audio);
    // v.init();
    // // v.play();
    // // setInterval(function () {
    // //   if(is_load_audio){

    // //   }
    // // },1000);

    // setInterval(function () {
    //   if (is_load_audio) {

    //     down_time_current -= 0.1;
    //     // $("#tip-msg").css("display", "");

    //     // $("tip-msg").css("color", "white");
    //     // if ($("#tip-msg").text() == b_loading_txt + "...") {
    //     //   $("#tip-msg").text(b_loading_txt);
    //     // } else {
    //     //   $("#tip-msg").text(b_loading_txt + "...");
    //     // }
    //     if (down_time_current < 0) {
    //       down_time_current = 0;
    //     }
    //     sessionStorage.setItem("down_time_current", down_time_current);
    //     // $("#tip-msg").html(b_loading_txt + "<br/>大约剩余 <span style='font-size: 1.2em;'>" + parseInt(down_time_current) + "</span> 秒"); //+ "<br/>" + anime.random(98, 128) + " k/s");


    //     if (v.ready) {
    //       // console.log("ready!");
    //       // $("#tip-msg").css("display", "none");
    //       is_load_audio = false;
    //       sessionStorage.setItem("is_load_audio", is_load_audio);
    //       is_ready = true;
    //       sessionStorage.setItem("is_ready", is_ready);
    //     } else if (v.loadFailed) {
    //       // console.log("加载失败");
    //       // $("tip-msg").css("color", "red");
    //       // $("#tip-msg").text(b_load_error_txt);
    //       is_ready = false;
    //       sessionStorage.setItem("is_ready", is_ready);
    //     }

    //   }

    //   if (v.playing) { //playing判断是否在播放
    //     is_ready = false;
    //     sessionStorage.setItem("is_ready", is_ready);
    //     // console.log(v.frequency);// frequency是长度为16的频率值数组
    //     frequencyData = [];
    //     for (let m = 0; m < v.frequency.length; m++) {
    //       frequencyData.push(v.frequency[m]);
    //     }
    //     // if (frequencyData = null){
    //     //   frequencyData = [];
    //     // }
    //     sessionStorage.setItem("frequencyData", JSON.stringify(frequencyData));
    //     /*
    //     clear_all(); // 清除画面

    //     for (let x = 0; x < 16; x++) {
    //       // let fft_data = Math.abs((v.frequency[x] - 128)/128);
    //       let fft_data = v.frequency[x] / 256;
    //       y = parseInt(grid_h * fft_data);


    //       // for(let row=0; row<y;row++){
    //       //   let color = 'rgb('+anime.random(0, 255)+','+anime.random(0, 255)+','+anime.random(0, 255)+')'
    //       //   $('#grid0-id > div:nth-child('+((grid_h - 1 - row)*16+x + 1)+')').css("background-color", color );
    //       //   $('#grid0-id > div:nth-child('+((grid_h - 1 - row)*16+x + 1)+')').css("opacity", 1);
    //       // }
    //       let color = 'rgb(' + anime.random(0, 255) + ',' + anime.random(0, 255) + ',' + anime.random(0, 255) + ')'
    //       $('#grid0-id > div:nth-child(' + ((grid_h - 1 - y) * 16 + x + 1) + ')').css("background-color", color);
    //       $('#grid0-id > div:nth-child(' + ((grid_h - 1 - y) * 16 + x + 1) + ')').css("opacity", 1);

    //       // $('#grid0-id > div:nth-child(' + (y * 16 + x + 1) + ')').css("background-color", color);
    //       // $('#grid0-id > div:nth-child(' + (y * 16 + x + 1) + ')').css("opacity", 1);

    //     }*/

    //   } else {
    //     if (v.ready && is_auto_play) {
    //       // is_auto_play = false;
    //       // v.init();
    //       // v.play();

    //       //   // animation0.pause();
    //       //   // animation1.pause();
    //       //   createBalloons(128);

    //     }

    //   }

    //   function shuffle (array) {
    //     let res = [], random;
    //     while (array.length > 0) {
    //       random = Math.floor(Math.random() * array.length);
    //       res.push(array[random]);
    //       array.splice(random, 1);
    //     }
    //     return res;
    //   }
    //   if (v.playing) {
    //     // $("#sound-btn").html('<i class="material-icons left">stop</i>' + b_stop_btn_txt);
    //     // $("#sound-btn").addClass("gray");
    //     // $("#sound-btn").removeClass("blue");
    //     $("#sound1-btn").css("display", "");
    //     $("#sound-btn").css("display", "none");

    //     // let colors = ["rgb(255, 0, 0)", "rgb(255, 127, 0)", "rgb(255, 255, 0)",
    //     //     "rgb(0, 255, 0)", "rgb(0, 255, 255)", "rgb(0, 0, 255)", "rgb(255, 0, 255)"]
    //     // let rcs = shuffle(colors);
    //     // let cs = "";
    //     // rcs.forEach((value)=>{
    //     //   cs += ", " + value;
    //     // });
    //     // $("body").css("background", "linear-gradient(to bottom right" + cs + ")");

    //   } else {
    //     // $("#sound-btn").html('<i class="material-icons left">music_note</i>' + b_play_btn_txt);
    //     // $("#sound-btn").addClass("blue");
    //     // $("#sound-btn").removeClass("gray");
    //     $("#sound1-btn").css("display", "none");
    //     $("#sound-btn").css("display", "");

    //     // $("body").css("background", "linear-gradient(to bottom right, rgb(255, 0, 0), rgb(255, 127, 0), rgb(255, 255, 0), rgb(0, 255, 0), rgb(0, 255, 255), rgb(0, 0, 255), rgb(255, 0, 255))");

    //   }

    //   if (is_load_audio) {
    //     $("#sound-btn").css("display", "none");
    //   }

    //   is_palying = v.playing;
    //   sessionStorage.setItem("is_palying", is_palying);
    // }, 10);

    // function change_music () {
    //   let music_index = sessionStorage.getItem("music_index") == null ? 0 : parseInt(sessionStorage.getItem("music_index"));
    //   music_index = music_index + 1;
    //   if(music_index >= audio_paths.length){
    //     music_index = 0;
    //   }
    //   sessionStorage.setItem("music_index", music_index);

    //   audio_path = audio_paths[music_index];
      
    //   v = new Visualizer({
    //     url: audio_path,//audio地址 没有写兼容跨域的方法，所以不能跨域
    //     loop: false//是否循环
    //   });

    //   music();
    //   setTimeout(()=>{
    //     music();
    //   }, 500);
    // }
    // function change_mode (index) {
    //   let mode_index = sessionStorage.getItem("mode_index") == null ? 0 : parseInt(sessionStorage.getItem("mode_index"));
    //   mode_index = mode_index + index;
    //   if (mode_index < 0) {
    //     mode_index = 0;
    //   }
    //   if (mode_index > 2) {
    //     mode_index = 2;
    //   }
    //   sessionStorage.setItem("mode_index", mode_index);

    //   if (mode_index > 0 && mode_index <=2) {
    //     $("#change-mode-left-btn").attr("disabled", false);
    //     $("#change-mode-left-btn").addClass("text-danger");
    //     $("#change-mode-left-btn").removeClass("text-secondary");
    //   }
    //   if (mode_index == 0) {
    //     $("#change-mode-left-btn").attr("disabled", true);
    //     $("#change-mode-left-btn").addClass("text-secondary");
    //     $("#change-mode-left-btn").removeClass("text-danger");
    //   }

    //   if (mode_index < 2 && mode_index >= 0) {
    //     $("#change-mode-right-btn").attr("disabled", false);
    //     $("#change-mode-right-btn").addClass("text-danger");
    //     $("#change-mode-right-btn").removeClass("text-secondary");
    //   }
    //   if (mode_index == 2) {
    //     $("#change-mode-right-btn").attr("disabled", true);
    //     $("#change-mode-right-btn").addClass("text-secondary");
    //     $("#change-mode-right-btn").removeClass("text-danger");

    //     music();
    //   }
    //   if(mode_index == 1){
    //     if(is_palying){
    //       music();
    //     }
    //   }

    //   if (mode_index == 0) {
    //     $("#mode-name").text("面板模式");
    //     $("#mode-desc").text("自由组合各种功能部件，丰富个性化选项。");
    //   } else if (mode_index == 1) {
    //     $("#mode-name").text("灯光模式");
    //     $("#mode-desc").text("实时动态调色，支持多种显示内容。");
    //   } else if (mode_index == 2) {
    //     $("#mode-name").text("律动模式");
    //     $("#mode-desc").text("随声音节奏变化，多种变化效果。");
    //   }
    // }
    // function music () {
    //   gainNode = v.audioContext.createGain();
    //   // console.debug(gainNode.gain.value);
    //   gainNode.gain.value = -gainNode.gain.value;
    //   // if ( $("#sound-btn").text() == "静音") {
    //   //   $("#sound-btn").text("听歌");
    //   // }else{
    //   //   $("#sound-btn").text("静音");
    //   // }
    //   is_auto_play = false;
    //   if (v.playing) {
    //     is_load_audio = false;
    //     sessionStorage.setItem("is_load_audio", is_load_audio);
    //     v.stop();
    //     // clear_all();
    //     // show_heart();
    //     // animation0.play();
    //     // animation1.play();
    //     // removeBalloons();
    //     sessionStorage.setItem("is_palying", true);
    //   } else {
    //     is_load_audio = true;
    //     sessionStorage.setItem("is_load_audio", is_load_audio);
    //     down_time_current = down_time_total;
    //     v.init();
    //     v.play();
    //     // animation0.pause();
    //     // animation1.pause();
    //     // createBalloons(128);
    //     sessionStorage.setItem("is_palying", false);
    //   }
    // }

    // $("#change-music-btn").click(function () {
    //   change_music();
    // });

    // $("#change-mode-left-btn").click(function () {
    //   change_mode(-1);
    // });
    // $("#change-mode-right-btn").click(function () {
    //   change_mode(1);
    // });

    // $("#sound-btn").click(function () {
    //   music();
    // });
    // $("#sound1-btn").click(function () {
    //   music();
    // });

    // console.debug("window size: " + screen.availWidth + " x " + screen.availHeight);
    // window.addEventListener('resize', function () {
    // })

    // sessionStorage.setItem("music_index", 0);
    // sessionStorage.setItem("mode_index", 0);
    // change_mode(0);
  }); // end of document ready
})(jQuery); // end of jQuery name space


